import { RandomAccessFileReader, IStreamBytesExtraOptions } from '../gflib/src/lib/byte-reader/types';
import { Buffer } from 'buffer';
import { Readable } from 'readable-stream';

export class ByteReaderBrowser implements RandomAccessFileReader {
	private _file: File;
	constructor(file: File) {
		this._file = file;
	}

	get size(): number {
		return this._file.size;
	}

	readBytes(start: number, length: number) {
		return new Promise<Buffer>((resolve, reject) => {
			const reader = new FileReader();

			reader.onloadend = evt => {
				const target = evt.target as any;
				if (target.readyState === FileReader.prototype.DONE) {
					resolve(Buffer.from(target.result));
				}
			};
			const blob = this._file.slice(start, start + length);
			reader.readAsArrayBuffer(blob);
		});
	}

	streamBytes(start: number, length: number, options?: IStreamBytesExtraOptions): NodeJS.ReadableStream {
		const chunkSize = options?.chunkSize || 256 * 1024;
		let offset = start;
		const end = start + length;
		// eslint-disable-next-line @typescript-eslint/no-this-alias
		const reader = this;

		return new Readable({
			highWaterMark: options?.highWaterMark,
			read() {
				if (offset >= end) {
					this.push(null);
					return;
				}
				const readLen = Math.min(chunkSize, end - offset);
				reader.readBytes(offset, readLen).then(
					(buf: Buffer) => {
						offset += readLen;
						this.push(buf);
					},
					(err: any) => this.destroy(err)
				);
			}
		}) as unknown as NodeJS.ReadableStream;
	}
}

export default ByteReaderBrowser;
